import { useBorrowerHowDidYouHear } from '../../../../../../../queries/BorrowerFields/CoreFields';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../../../components/ApplicationQuestionReviewItem';

interface HowDidYouFindUsProps {
    required?: boolean;
    isReview?: boolean;
}

export const HowDidYouFindUs: React.FC<HowDidYouFindUsProps> = ({ required = false, isReview = false }) => {
    const label = 'How did you find us?';
    const [howDidYouHear, set_howDidYouHear] = useBorrowerHowDidYouHear();
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={howDidYouHear}
                />
            ) : (
                <TextBox
                    value={howDidYouHear}
                    onChange={set_howDidYouHear}
                    label={label}
                    required={required}
                    placeholder='Referral, ad, internet search, etc.'
                />
            )}
        </>
    );
};
